import React, { useEffect, useRef } from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { useDispatch, useSelector } from "react-redux";
import { getAllMainBanner } from "../../State/Banner/Action";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader/Loader";

const MainCarosel = () => {
  const carouselRef = useRef();
  const { publicBanners } = useSelector((store) => store);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleBannerClick = (item) => {
    const brandName = item.brand?.name;
    const vendorName = item.vendor?.name;
    const discounts = item.associatedLinks?.map((link) => link.discountPercentage).join(",");
    const specialDiscounts = item.specialOffers?.map((link) => link.discountPercentage).join(",");

    if (item.bannerType === "PRODUCT_SPECIFIC") {
      if (brandName && vendorName && item.associatedLinks?.length) {
        navigate(`/collections/${vendorName}/brand/${brandName}/sales/${discounts}`);
      } else if (brandName && item.associatedLinks?.length) {
        navigate(`/collections/brand/${brandName}/sales/${discounts}`);
      } else if (vendorName && item.associatedLinks?.length) {
        navigate(`/collections/vendor/${vendorName}/sales/${discounts}`);
      } else if (vendorName && brandName) {
        navigate(`/collections/${vendorName}/brand/${brandName}`);
      } else if (brandName) {
        navigate(`/collections/brand/${brandName}`);
      } else if (vendorName) {
        navigate(`/collections/vendor/${vendorName}`);
      } else {
        navigate(`/sales/${discounts || ""}`);
      }
    } else if (item.bannerType === "PLATFORM_SPECIFIC") {
      navigate(`/sales/${discounts || ""}`);
    } else {
      navigate(`/festival-offers/${specialDiscounts || ""}`);
    }
  };

  const items = publicBanners.main?.response?.map((item) => (
    <section
      key={item.id}
      className="relative group cursor-pointer"
      onClick={() => handleBannerClick(item)}
    >
      <div className="relative h-[26vh] w-full overflow-hidden rounded-none rounded-b-[16px] bg-neutral-100 sm:h-[40vh] md:h-[52vh] md:rounded-b-[20px] lg:h-[62vh]">
        <img
          src={item.imageUrl || "/placeholder.svg?height=1080&width=1920"}
          alt={item.brand?.name || "Fashion collection"}
          className="h-full w-full object-cover object-center transition-transform duration-700 ease-out group-hover:scale-[1.02]"
          loading="lazy"
        />
      </div>
    </section>
  ));

  useEffect(() => {
    dispatch(getAllMainBanner());
  }, [dispatch]);

  return publicBanners.loading ? (
    <Loader />
  ) : (
    <div className="relative z-0">
      <div className="mx-auto max-w-7xl px-3 sm:px-4">
        <div className="relative">
          <AliceCarousel
            ref={carouselRef}
            items={items}
            disableButtonsControls={false}
            autoPlay
            autoPlayInterval={8000}
            infinite
            controlsStrategy="responsive"
            disableDotsControls
            renderPrevButton={() => (
              <button
                className="absolute left-2 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border-0 bg-white/90 shadow-sm hover:bg-white sm:left-4"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="#1c1917" className="w-5 h-5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
              </button>
            )}

            renderNextButton={() => (
              <button
                className="absolute right-2 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border-0 bg-white/90 shadow-sm hover:bg-white sm:right-4"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="#1c1917" className="w-5 h-5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default MainCarosel;
